<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">
          {{alert.message}}
        </p>
        <ul v-else>
          <li v-for="e in alert.message">
            {{e}}
          </li>
        </ul>
      </b-alert>
    </template>
    <template v-if="notFound">
      <div class="error-page">
        <h2 class="headline text-danger"> 404</h2>
        <div class="error-content">
          <h3><i class="fa fa-warning text-danger"></i> Oops! Order not found.</h3>
          <p>
            We could not find the product you were looking for.
            Meanwhile, you may <a href="/home">return to dashboard</a>
          </p>
          <br>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Art. # {{product.wws_model}}</h3>
            </div>
            <div class="box-controls">
              <div class="row">
               <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                  <label for="inputTitle" class="control-label">Status:</label>
                  <div class="btn-group btn-sm" data-toggle="btn-toggle">
                    <button type="button" @click="() => {product.is_active = true; activate([])}" :class="['btn btn-success', product.is_active ? 'active' : '']"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</button>
                    <button type="button" @click="() => {product.is_active = false; activate([])}" :class="['btn btn-danger', product.is_active ? '' : 'active']"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
                  </div>
                </div>
                <div class="col-lg-8 col-md-6 col-sm-6 col-xs-12 pull-right">
                  <div class="margin visible-xs"></div>
                  <div class="input-group">
                    <div class="input-group-addon">
                      Filiale:
                    </div>
                    <multiselect v-model="selectedStore" :options="stores" label="calculatedName" track-by="id" :loading="isLoading"></multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-body">
              <template v-if="loading">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <img class="loading-gif" src="/static/img/blabla.svg"/>
                  </div>
                </div>
              </template>
             <template v-else>
               <div class="row">
                 <div class="col-lg-4 col-md-12">
                   <div class="row">
                     <div class="col-lg-7 col-md-6 col-xs-12">
                       <ul class="list-group list-group-unbordered small">
                         <li class="list-group-item"><span><strong>{{'brand' | translate}}:</strong></span><span class="pull-right">{{product.brand}}</span></li>
                         <li class="list-group-item"><span><strong>{{'image_id' | translate}}:</strong><span class="pull-right">{{product.img_id}}</span></span></li>
                         <li class="list-group-item"><span><strong>{{'erp_id' | translate}}:</strong><span class="pull-right">{{product.wws_model}}</span></span></li>
                         <li class="list-group-item"><span><strong>{{'erp_number' | translate}}:</strong></span><span class="pull-right">{{product.wws_number}}</span></li>
                         <li class="list-group-item"><span><strong>{{'producer_model' | translate}}:</strong></span><span class="pull-right">{{product.producer_model}}</span></li>
                       </ul>
                     </div>
                     <div class="col-lg-5 col-md-6 col-xs-12">
                       <img class="img-responsive" :src="product.image" alt="Image">
                     </div>
                   </div>
                 </div>
                 <div class="col-lg-8 col-md-12">
                   <div class="table-responsive">
                     <table class="table table-hover table-bordered">
                       <thead>
                       <tr>
                         <th>{{'size' | translate}}</th>
                         <th>EAN</th>
                         <th>UVP</th>
                         <th>VK-{{'price' | translate}}</th>
                         <th>{{'quantity' | translate}}</th>
                         <th>{{'store' | translate}}</th>
                       </tr>
                       </thead>
                       <tbody>
                       <template v-for="size in product.sizes">
                         <tr v-if="size.storeId === selectedStore.id || selectedStore.id === 0 || selectedStore === ''">
                           <td><strong>{{size.size}}</strong></td>
                           <td>{{size.ean}}</td>
                           <td>{{size.original_price | currency}}</td>
                           <td>{{size.sale_price | currency}}</td>
                           <td>{{size.stock}}</td>
                           <td>{{size.storeId}} - {{size.store_information}}</td>
                         </tr>
                       </template>
                       </tbody>
                     </table>
                   </div>
                 </div>
               </div>
               <hr>
               <div class="row">
                 <div class="col-xs-12">
                   <label class="control-label pb-10">{{'sales_channels' | translate}}:</label>
                 </div>
                 <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" v-for="channel in product.channels">
                   <img class="img-responsive img-channel mb-10" :src="'/static/img/schuhede-' + channel.name + '.svg'">
                   <div class="btn-group pb-10" data-toggle="btn-toggle">
                     <button type="button" @click="activate([{name: channel.name, active: true}])" :class="['btn btn-success', channel.active ? 'active' : '']"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</button>
                     <button type="button" @click="activate([{name: channel.name, active: false}])" :class="['btn btn-danger', channel.active ? '' : 'active']"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
                   </div>
                 </div>
               </div>
             </template>
            </div>
            <div class="box-footer"></div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
export default {
  data () {
    return {
      goto: '',
      isLoading: true,
      notFound: false,
      loading: false,
      alerts: [],
      error: {},
      product: {},
      stores: [{
        id: 0,
        name: 'Alle Filialen',
        calculatedName: 'Alle Filialen'
      }],
      selectedStore: {
        id: 0,
        name: 'Alle Filialen',
        calculatedName: 'Alle Filialen'
      }
    }
  },
  methods: {
    goToMp () {
      API.get(`/orders?ext_order_id=${this.gotoMP}`)
        .then(response => {
          if (response.data.data.length > 1 || response.data.data.length === 0) {
            this.$router.push('/orders/error')
          } else {
            this.$router.push('/orders/' + response.data.data[0].id)
          }
        })
    },
    alertError (value) {
      $('#closeRefundModal').click()
      this.alerts.push({dismiss: 4, type: 'danger', message: [value], icon: 'icon fa fa-ban', show: true})
    },
    alert (value) {
      let alert
      if (value.status === 200 || value.status === 204 || value.status === 202) {
        alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
      } else if (value.status === 0) {
        alert = {dismiss: 4, type: 'warning', message: 'Not modified', icon: 'icon fa fa-warning', show: true}
      } else {
        alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + value.data.message, icon: 'icon fa fa-ban', show: true}
      }
      this.alerts.push(alert)
    },
    getProduct () {
      let url = `/inventory/${this.$route.params.company}/${this.$route.params.id}`
      API.get(url)
        .then(response => {
          this.product = response.data
          this.product.marketplaces = {}
          response.data.stores.forEach(s => {
            s.calculatedName = `${s.name} - ${s.zip} - ${s.city} ${s.erp_store_id ? '(' + s.erp_store_id + ')' : ''}`
            this.stores.push(s)
          })
          this.isLoading = false
          this.loading = false
        })
        .catch(error => {
          this.notFound = error.response.status === 404
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          if (!error.response.status === 404) {
            this.alerts.push(alert)
          }
          this.loading = false
        })
    },
    getStore (id) {
      for (let s in this.stores) {
        if (this.stores[s].id === id){
          return this.stores[s].id + ' - ' + this.stores[s].name + ', ' + this.stores[s].zip + ' ' + this.stores[s].city
        }
      }
    },
    activate (channels) {
      API.put(`/inventory/${this.$route.params.company}/${this.$route.params.id}`, {product_active: this.product.is_active, channels: channels})
        .then(res => {
          if (channels.length > 0) {
            this.product.channels.find(a => { return a.name === channels[0].name }).active = channels[0].active
            this.alert(res)
          }
        })
        .catch(error => {
          this.alert(error)
        })
    }
  },
  mounted () {
    if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
      this.loading = true
      this.getProduct()
    }
  },
  watch: {
    '$route.params.id' () {
      this.loading = true
      this.notFound = false
      this.getProduct()
    },
    product () {}
  }
}
</script>
<style>
  .special {
    font-size: 0.975rem;
    font-weight: bold;
  }
  .overlay {
    z-index: 50;
    background: rgba(33,34,40,.75);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
  }
  .overlay-text{
    position: absolute;
    top: 54%;
    left: 49%;
    margin-left: -1rem;
    margin-top: -1rem;
  }
  .overlay > .fa {
    position: absolute;
    top: 50%;
    left: 57%;
    margin-left: -1rem;
    margin-top: -1rem;
    color: currentColor;
    font-size: 2rem;
    opacity: 0.65;
  }
  select option.danger {
    margin: 40px;
    background:rgb(86, 32, 27);
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  select option.normal {
    margin: 40px;
    background:rgb(32, 34, 39);
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  select option.warning {
    margin: 40px;
    background:#5e4219;
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__spinner {
    background: #282a31 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }
</style>
<style scoped>
  .alert.alert-message {
    position: fixed;
  }
  .alert-dismissible {
    z-index: 9999;
    position: fixed;
    width: 300px;
    top: 60px;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/SingleProduct.vue